import {Platform} from 'react-native';

import VisitWebsitePopover from '/component/partial/VisitWebsitePopover';
import {openURL, openURLInNewTabOnWeb} from '/util/linking.util';

export const generateOnLearnMore = (
  {popoverShow}: any,
  currentScreen: any,
  URL: any,
) => {
  return () => {
    if (Platform.OS === 'web') {
      openURLInNewTabOnWeb(URL);
      return;
    }

    popoverShow(VisitWebsitePopover, {
      currentScreen: currentScreen,
      destinationURL: URL,
      onSubmit: () =>
        openURL(
          'url',
          'https://coachanswers.optavia.com/help/client-support-bonus-plus',
        ),
    });
  };
};
